// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"1f515221","1626":"1f515221","2228":"1f515221","2248":"1f515221","2460":"1f515221","3953":"1f515221","5555":"1f515221","5717":"89ad6120","6533":"8df00897","6784":"1f515221"}[chunkId] + ".chunk.css";
};